import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {FormControl, FormGroup} from "@angular/forms";
import {latitudeCheck, longitudeCheck, required} from "../../../../../../../shared/utils";
import {EditPermissions} from "../../../../../../../shared/models";
import {getEditTypes} from "../../../delegatorUtils";


export interface InboundLocationForm {
    text: string,
    name: string,
    header: string,
    imageRef: string,
    next: string,
    direction: 'inbound',
}

export interface OutboundLocationForm {
    name: string,
    bodyText: string,
    locationName: string,
    locationLatitude: string,
    locationLongitude: string,
    locationAddress: string,
    next: string,
    direction: 'outbound'
}

export class LocationNode {

    private menu: any = {};

    constructor() {
        this.menu = {
            'menuType': 'location',
        };
    }

    public static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
        const menu = stepData?.menu;
        const direction = menu?.menuParams?.direction;
        return this.getForm(direction, stepData, editPermissions);
    }

    public static getForm(direction: string, stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        switch (direction) {
            case "outbound":
                return this.outboundForm(stepData, editFlows);
            default:
                return this.inboundForm(stepData, editFlows);
        }
    }

    private static outboundForm(stepData: { [index: string]: any }, editFlows: boolean): FormGroup {
        const outboundForm: OutboundLocationForm = this.toOutbound(stepData);
        return new FormGroup({
            name: new FormControl({
                value: outboundForm.name,
                disabled: !editFlows
            }, [required('Name')]),
            bodyText: new FormControl({
                value: outboundForm.bodyText,
                disabled: !editFlows
            }, [required('Body text')]),
            locationAddress: new FormControl({
                value: outboundForm.locationAddress,
                disabled: !editFlows
            }, [required('Address')]),
            locationLatitude: new FormControl({
                value: outboundForm.locationLatitude,
                disabled: !editFlows
            }, [required('Latitude'), latitudeCheck("Latitude")]),
            locationName: new FormControl({
                value: outboundForm.locationName,
                disabled: !editFlows
            }, [required('Location Name')]),
            locationLongitude: new FormControl({
                value: outboundForm.locationLongitude,
                disabled: !editFlows
            }, [required('Longitude'), longitudeCheck('Longitude')]),
            next: new FormControl({
                value: outboundForm.next,
                disabled: !editFlows
            }, []),
            direction: new FormControl({
                value: outboundForm.direction,
                disabled: !editFlows
            }, []),
        })
    }

    private static inboundForm(stepData: { [index: string]: any }, editFlows: boolean): FormGroup {
        const inboundForm: InboundLocationForm = this.toInbound(stepData);
        return new FormGroup({
            text: new FormControl({
                value: inboundForm.text,
                disabled: !editFlows
            }, [required('Text')]),
            name: new FormControl({
                value: inboundForm.name,
                disabled: !editFlows
            }, [required('Name')]),
            header: new FormControl({
                value: inboundForm.header,
                disabled: !editFlows
            }, []),
            imageRef: new FormControl({
                value: inboundForm.imageRef,
                disabled: !editFlows
            }, []),
            direction: new FormControl({
                value: inboundForm.direction,
                disabled: !editFlows
            }, []),
            next: new FormControl({
                value: inboundForm.next,
                disabled: !editFlows
            }, []),
        })
    }

    private static toOutbound(stepData: { [index: string]: any }): OutboundLocationForm {
        const menu = stepData?.menu ? stepData?.menu : undefined;
        const menuParams = menu?.menuParams ? menu?.menuParams : undefined;

        return {
            name: this.getOrDefault(menu?.name),
            bodyText: this.getOrDefault(menu?.bodyText),
            locationAddress: this.getOrDefault(menuParams?.locationAddress),
            locationLatitude: this.getOrDefault(menuParams?.locationLatitude),
            locationName: this.getOrDefault(menuParams?.locationName),
            locationLongitude: this.getOrDefault(menuParams?.locationLongitude),
            next: this.getOrDefault(stepData?.next, newStepValue),
            direction: "outbound"
        }
    }

    private static toInbound(stepData: { [index: string]: any }): InboundLocationForm {
        const menu = stepData?.menu ? stepData?.menu : undefined;
        const menuParams = menu?.menuParams ? menu?.menuParams : undefined;
        return {
            name: this.getOrDefault(menu?.name),
            text: this.getOrDefault(menu?.text),
            header: this.getOrDefault(menuParams?.header),
            imageRef: this.getOrDefault(menu?.imageRef),
            next: this.getOrDefault(stepData?.next, newStepValue),
            direction: "inbound"
        }
    }

    private static getOrDefault(value: string, defaultValue: any = ""): any {

        if (value === undefined || !value) {
            return defaultValue
        }

        return value;
    }

   public setMenu(rawData: InboundLocationForm | OutboundLocationForm): void {
        const menuParams = {
            direction: rawData.direction
        };
        const menu = {
            ...this.menu,
            name: rawData.name
        };
        switch (rawData.direction) {
            case "outbound":
                menu['bodyText'] = rawData.bodyText;
                menuParams['locationName'] = rawData.locationName;
                menuParams['locationLatitude'] = rawData.locationLatitude;
                menuParams['locationLongitude'] = rawData.locationLongitude;
                menuParams['locationAddress'] = rawData.locationAddress;
                break
            case "inbound":
                menu['text'] = rawData.text;
                if (rawData.header !== undefined && rawData.header.length > 0) {
                    menuParams['header'] = rawData.header;
                } else if (rawData.imageRef !== undefined && rawData.imageRef.length > 0) {
                    menu['imageRef'] = rawData.imageRef;
                }
                break
        }
        this.menu = {
           ...menu,
            menuParams
        }
    }

    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            'next': newStepValue,
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

}


// {
//     menu: {
//         menuType: 'location',
//             name: '',
//             bodyText: '',
//             menuParams: {
//                 direction: 'outbound',
//                 locationName: '',
//                 locationLatitude: '',
//                 locationLongitude: '',
//                 locationAddress: '',
//         },
//     },
//     type: 'menu',
//         next: newStepValue,
//     metadata: {},
// }
// menu: {
//     menuType: 'location',
//         text: '',
//         name: '',
//         menuParams: {
//               direction: 'inbound',
//     },
// },
// type: 'menu',
//     next: newStepValue,
//     metadata: {},
// }